import React from 'react';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { PreviewSection } from './components/PreviewSection';
import { IncludedSection } from './components/IncludedSection';
import { ChaptersSection } from './components/ChaptersSection';
import { VisualTypesSection } from './components/VisualTypesSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { OfferSection } from './components/OfferSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FaqSection } from './components/FaqSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen w-full bg-night font-body text-cream" data-id="element-0" data-mp="2wk9zanmsgt0o">
      <Hero data-id="element-1" data-mp="2whxd1y9zzwht" />
      <main data-id="element-2" data-mp="28ufo0ai4bcij">
        <ProblemSection data-id="element-3" data-mp="28u5vaf5our95" />
        <PreviewSection data-id="element-4" data-mp="28te3lff7pdo5" />
        <IncludedSection data-id="element-5" data-mp="28sl48zil1qg1" />
        <ChaptersSection data-id="element-6" data-mp="23vcjcr61v8b3" />
        <VisualTypesSection data-id="element-7" data-mp="23vulg4fe8gqx" />
        <TestimonialsSection data-id="element-8" data-mp="23utcc5hxu4bu" />
        <OfferSection data-id="element-9" data-mp="23ti864kkyuk7" />
        <GuaranteeSection data-id="element-10" data-mp="3ik7e6ay3c1o0" />
        <FaqSection data-id="element-11" data-mp="3iiwfuqnezm4a" />
      </main>
      <Footer data-id="element-12" data-mp="3ihv22ef0kliv" />
    </div>;
}